import classNames from "classnames";
import { CSSProperties } from "react";
import {
  TIMELINE_OVERDUE_COLOR,
  TIMELINE_STATUS,
  TIMELINE_STATUS_COLOR,
  TIMELINE_UNPAID_BORDER_COLOR,
  type TimelineStatus,
} from "constants/filingsTimeline";
import { colors } from "constants/colors";

type TimelineStatusDotProps = {
  status: TimelineStatus;
  isOverdue?: boolean;
  className?: string;
};

export const TimelineStatusDot = ({
  status,
  isOverdue = false,
  className = "t-h-1.5 t-w-1.5",
}: TimelineStatusDotProps) => {
  const isUnpaid = status === TIMELINE_STATUS.UNPAID;
  const isOutlined = isOverdue || isUnpaid;

  let style: CSSProperties = { backgroundColor: TIMELINE_STATUS_COLOR[status] };

  if (isUnpaid) {
    style = {
      backgroundColor: colors.white,
      borderColor: TIMELINE_UNPAID_BORDER_COLOR,
    };
  }

  if (isOverdue) {
    style = {
      backgroundColor: colors.white,
      borderColor: TIMELINE_OVERDUE_COLOR,
    };
  }

  return (
    <span
      style={style}
      className={classNames("t-shrink-0 t-rounded-full", className, {
        "t-border t-border-solid": isOutlined && !isUnpaid,
        "t-border t-border-dashed": isUnpaid,
        "t-border-0": !isOutlined,
      })}
    />
  );
};
